/*
  dbp-searchall — opens the full product list as soon as the search field is
  focused, and gets out of the way the moment the visitor types.

  Why it does not hook into Dawn's PredictiveSearch class: that component only
  reacts to a non-empty term (onFocus and onChange both bail on an empty query),
  and it owns the innerHTML of [data-predictive-search]. Rather than patch it,
  this drives a sibling panel and mirrors the same show/hide moments.

  The two panels are mutually exclusive by construction: ours is open only while
  the input is empty, and Dawn only sets [open] once a term exists.
*/
(function () {
  var BLUR_GRACE_MS = 120;

  function wire(panel) {
    if (panel.dataset.dbpSearchallBound === 'true') return;
    panel.dataset.dbpSearchallBound = 'true';

    var form = panel.closest('form');
    if (!form) return;
    var input = form.querySelector('.search__input');
    if (!input) return;

    // Scope focus checks to the custom element when predictive search is on,
    // and to the form when it is off — either way it is the subtree that counts
    // as "still inside the search".
    var scope = form.closest('predictive-search') || form;
    var hideTimer = null;

    function isEmpty() {
      return input.value.trim().length === 0;
    }

    function show() {
      window.clearTimeout(hideTimer);
      panel.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }

    function hide() {
      panel.classList.remove('is-open');
      // Only surrender aria-expanded when Dawn is not showing its own results,
      // otherwise we would contradict the state it just set.
      if (!scope.hasAttribute || !scope.hasAttribute('open')) {
        input.setAttribute('aria-expanded', 'false');
      }
    }

    function sync() {
      if (isEmpty() && document.activeElement === input) show();
      else hide();
    }

    input.addEventListener('focus', sync);
    input.addEventListener('input', sync);
    input.addEventListener('click', sync);

    // The reset button clears the field without firing `input` in every browser.
    var reset = form.querySelector('button[type="reset"]');
    if (reset) {
      reset.addEventListener('click', function () {
        window.setTimeout(sync, 0);
      });
    }

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') hide();
    });

    // A tap on a product link blurs the input before the navigation commits, so
    // the panel has to outlive the blur by a beat or the link never fires.
    scope.addEventListener('focusout', function () {
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () {
        if (!scope.contains(document.activeElement)) hide();
      }, BLUR_GRACE_MS);
    });

    panel.addEventListener('pointerdown', function () {
      window.clearTimeout(hideTimer);
    });

    // Closing the header's search modal leaves the input blurred but the panel
    // class intact; reset it so the next open starts clean.
    var modal = form.closest('details-modal');
    if (modal) {
      var details = modal.querySelector('details');
      if (details) {
        details.addEventListener('toggle', function () {
          if (!details.open) hide();
        });
      }
    }
  }

  function init(root) {
    (root || document).querySelectorAll('.dbp-searchall').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // The header re-renders in the theme editor and after section reloads.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
